import React, { use, useEffect, useState } from "react";
import "../css/capital.css";
import AddPartnerModal from "../components/capital/AddPartner";
import AddInvestmentModal from "../components/capital/AddInvestor";
import PartnersTable from "../components/capital/PartnersTable";
import TotalInvestment from "../components/capital/TotalInvestment";
import PageHeader from "../components/capital/PageHeader";
import TopActionButtons from "../components/capital/TopActionButtons";
import BusinessCapital from "../components/capital/BusinessCapital";
import ProfitLoss from "../components/capital/ProfitAndLoss";
import SummarySection from "../components/capital/SummarySection";
import SummaryCard from "../components/capital/SummaryCard";
import { createPartner, getPartners } from "../services/partnerService";
import {
  createInvestment,
  getInvestmentStatsAPI,
} from "../services/investmentService";
import { investmentObject } from "../utils/transform";
import CapitalModalUpdate from "../components/common/CapitalUpdateModal";
import { getAmountInCurrencyFormat, limitNumber } from "../utils/number";
import BusinessValue from "../components/capital/BusinessValue";

export default function Capital() {
  const [showPartnerModal, setShowPartnerModal] = useState(false);
  const [showInvestModal, setShowInvestModal] = useState(false);
  const [partnersData, setPartnersData] = useState([]);
  const [investmentStats, setInvestmentStats] = useState({});
  const [loadingPartners, setLoadingPartners] = useState(false);
  const [loadingInvestment, setLoadingInvestment] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    getPartnersData();
  }, []);

  async function getPartnersData() {
    setLoadingPartners(true);
    try {
      const response = await getPartners();
      console.log(response);
      if (response.success) {
        setPartnersData(response.partners);
        return response.partners;
      }
    } catch (err) {
    } finally {
      setLoadingPartners(false);
      getInvestmentStats();
    }
    return null;
  }
  async function getInvestmentStats() {
    try {
      const response = await getInvestmentStatsAPI();
      console.log(response);
      if (response.success) {
        setInvestmentStats(response.data);
      }
    } catch (err) {
      console.error("investment stats eror", err.message);
    } finally {
    }
    return null;
  }

  const handlePartnerSave = async (partnerData) => {
    try {
      const response = await createPartner(partnerData);

      if (response.success) {
        getPartnersData();
        return { success: true, message: "Added Successfully" };
      } else {
        return { success: false, error: "Unknown error occured!" };
      }
    } catch (err) {
      const error =
        err.response?.data?.message || "Error while creating the partner";
      return {
        success: false,
        error,
      };
    }
  };

  const handleInvestmentSave = async (investmentFormData) => {
    try {
      setLoadingInvestment(true);
      console.log({ investmentFormData });
      // const transformed = investmentFormData;
      // console.log({ transformed });
      // if (transformed?.errors?.length > 0) {
      //   return alert("Errors in forms");
      // }

      // const investmentObj = transformed.investment;

      const response = await createInvestment(investmentFormData);
      console.log(response);

      getPartnersData();
      return true;
    } catch (err) {
      console.log(err);
      return false;
    } finally {
      setLoadingInvestment(false);
    }
  };

  const { profit, loss } = getProfitLossData(investmentStats);
  return (
    <>
      <PageHeader onOpen={() => setOpen(true)} />
      {/* MAIN CONTENT START */}
      <TopActionButtons
        setShowInvestModal={setShowInvestModal}
        setShowPartnerModal={setShowPartnerModal}
      />
      {/* Partners Table */}
      <PartnersTable
        partnersData={partnersData}
        getPartnerRefresh={getPartnersData}
        partnersLoading={loadingPartners}
      />
      {/* Total Investment */}
      {/* <TotalInvestment value={"Rs. 0"} /> */}
      {/* Business Capital */}

      {/* In hand and ow to customer */}
      <BusinessCapital
        inHand={{
          gold: `${limitNumber(investmentStats?.inventoryInHand?.gold || 0)} g`,
          silver: `${limitNumber(investmentStats?.inventoryInHand?.silver || 0)} g`,
          cash: `PKR ${getAmountInCurrencyFormat(investmentStats?.inventoryInHand?.cash || 0)}`,
        }}
        payToMarket={{
          gold: `${limitNumber(investmentStats?.oweToCustomers?.payable?.gold || 0)} g`,
          silver: `${limitNumber(investmentStats?.oweToCustomers?.payable?.silver || 0)} g`,
          cash: `PKR ${getAmountInCurrencyFormat(investmentStats?.oweToCustomers?.payable?.cash || 0)}`,
        }}
      />
      {/* Total investment */}
      <SummarySection>
        <SummaryCard
          icon="fa-solid fa-sack-dollar"
          title="Total Investment"
          total={
            "PKR " +
            getAmountInCurrencyFormat(
              investmentStats?.totalInvestments?.totalAmount || 0,
            )
          }
          items={[
            {
              label: "Total Investment Gold",
              value: limitNumber(investmentStats?.totalInvestments?.gold || 0),
            },
            {
              label: "Total Investment Silver",
              value: limitNumber(
                investmentStats?.totalInvestments?.silver || 0,
              ),
            },
            {
              label: "Total Investment Cash",
              value: getAmountInCurrencyFormat(
                investmentStats?.totalInvestments?.cash || 0,
              ),
            },
          ]}
        />
      </SummarySection>

      <BusinessValue
        netPosition={
          investmentStats?.netPosition || { gold: 0, silver: 0, cash: 0 }
        }
      />
      {/* Profit & Loss */}
      <ProfitLoss
        profit={{
          gold: `${limitNumber(profit.gold)} g`,
          silver: `${limitNumber(profit.silver)} g`,
          cash: `PKR ${getAmountInCurrencyFormat(profit.cash)}`,
        }}
        loss={{
          gold: `${limitNumber(loss.gold)} g`,
          silver: `${limitNumber(loss.silver)} g`,
          cash: `PKR ${getAmountInCurrencyFormat(loss.cash)}`,
        }}
      />
      <AddPartnerModal
        show={showPartnerModal}
        isLoading={loadingPartners}
        onClose={() => setShowPartnerModal(false)}
        onSave={handlePartnerSave}
      />

      <AddInvestmentModal
        show={showInvestModal}
        onClose={() => setShowInvestModal(false)}
        onSave={handleInvestmentSave}
        partners={partnersData}
        isLoading={loadingInvestment}
      />

      {open && <CapitalModalUpdate show={open} setShow={setOpen} />}
    </>
  );
}

const getProfitLossData = (investmentStats) => {
  const data = investmentStats?.profitOrLoss || {};

  const profit = { gold: 0, silver: 0, cash: 0 };
  const loss = { gold: 0, silver: 0, cash: 0 };

  ["gold", "silver", "cash"].forEach((key) => {
    const item = data[key];

    if (!item || item.status === "-") return;

    if (item.status === "PROFIT") {
      profit[key] = item.value;
    } else if (item.status === "LOSS") {
      loss[key] = item.value;
    }
  });

  return { profit, loss };
};

/* Summary Cards */

// <SummarySection>
//   {/* <SummaryCard
//     icon="fa-solid fa-coins"
//     title="Total Capital"
//     total="Rs. 500000"
//     items={[
//       { label: "Total Capital Gold", value: "200g" },
//       { label: "Total Capital Silver", value: "400g" },
//       { label: "Total Capital Cash", value: "Rs. 200000" },
//     ]}
//   /> */}

//   <SummaryCard
//     icon="fa-solid fa-sack-dollar"
//     title="Total Investment"
//     total={
//       "PKR " +
//       getAmountInCurrencyFormat(
//         investmentStats?.totalInvestments?.totalAmount || 0,
//       )
//     }
//     items={[
//       {
//         label: "Total Investment Gold",
//         value: limitNumber(investmentStats?.totalInvestments?.gold || 0),
//       },
//       {
//         label: "Total Investment Silver",
//         value: limitNumber(
//           investmentStats?.totalInvestments?.silver || 0,
//         ),
//       },
//       {
//         label: "Total Investment Cash",
//         value: getAmountInCurrencyFormat(
//           investmentStats?.totalInvestments?.cash || 0,
//         ),
//       },
//     ]}
//   />

//   <SummaryCard
//     icon="fa-solid fa-handshake"
//     title="Total In Hand"
//     total="Rs. 0"
//     items={[
//       { label: "Total In Hand Gold", value: 0 },
//       { label: "Total In Hand Silver", value: 0 },
//       { label: "Total In Hand Cash", value: 0 },
//     ]}
//   />
//   <SummaryCard
//     icon="fa-solid fa-chart-line"
//     title="Total Pay To Market"
//     total="Rs. 0"
//     items={[
//       { label: "Total Pay To Market Gold", value: 0 },
//       { label: "Total Pay To Market Silver", value: 0 },
//       { label: "Total Pay To Market Cash", value: 0 },
//     ]}
//   />

//   <SummaryCard
//     icon="fa-solid fa-chart-line"
//     title="Total Profit"
//     total="Rs. 0"
//     items={[
//       { label: "Total Profit Gold", value: 0 },
//       { label: "Total Profit Silver", value: 0 },
//       { label: "Total Profit Cash", value: 0 },
//     ]}
//   />
//   <SummaryCard
//     icon="fa-solid fa-arrow-trend-down"
//     title="Total Loss"
//     total="Rs. 0"
//     items={[
//       { label: "Total Loss Gold", value: 0 },
//       { label: "Total Loss Silver", value: 0 },
//       { label: "Total Loss Cash", value: 0 },
//     ]}
//   />

//   <SummaryCard
//     icon="fa-solid fa-coins"
//     title="Current Capital"
//     total="Rs. 0"
//     items={[
//       { label: "Current Capital Gold", value: 0 },
//       { label: "Current Capital Silver", value: 0 },
//       { label: "Current Capital Cash", value: 0 },
//     ]}
//   />
// </SummarySection>
